"use client";

import { ErrorPage } from "@/app/global-error";
import { Button } from "@/components/ui/button";

const RootErrorPage = ({
  error: _error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) => {
  return (
    <ErrorPage
      errorCode="500"
      actionButtonElement={
        <Button variant="primary" onClick={() => reset()}>
          再読み込み
        </Button>
      }
    />
  );
};

export default RootErrorPage;
